/* SerranoMarkt | BTS ready-set offer and init | QA only */
(() => {
  'use strict';
  const B = window.SerranoBtsSecondBox;
  if (!B || !B.enhanceBuilder || B.readyInit) return;
  B.readyInit = true;

  const currentVariantId = (marker) => {
    const scope = marker.parentElement || document;
    const selector = scope.querySelector('form[data-product-form] [name="id"]') || scope.querySelector('form[action*="/cart/add"] [name="id"]');
    return B.numericId(selector?.value || marker.dataset.btsVariantId);
  };
  const seedFrom = (marker) => ({
    variantId: currentVariantId(marker),
    price: B.number(marker.dataset.btsPrice),
    pack: B.number(marker.dataset.btsPackSize),
    title: marker.dataset.btsTitle || 'Daily Nuuds kutusu'
  });
  const enhanceReady = (marker) => {
    if (!marker || marker.dataset.btsReadyEnhanced === 'true') return;
    const scope = marker.parentElement;
    const action = scope?.querySelector('.serrano-product-actions') || scope?.querySelector('.add-to-cart-btn')?.parentElement;
    if (!scope || !action) return;
    const seed = seedFrom(marker);
    if (!seed.variantId || !seed.price || seed.pack !== 5) return;
    marker.dataset.btsReadyEnhanced = 'true';
    const offer = document.createElement('div');
    offer.className = 'bts2-ready-offer';
    offer.innerHTML = `<button type="button" class="bts2-ready-trigger" aria-expanded="false"><span class="bts2-ready-trigger__eyebrow" style="color:#8e7e34!important;">MUHTEŞEM KASIM · BU SETE ÖZEL</span><strong class="bts2-ready-trigger__title" data-bts2-title style="color:#ff4712!important;">Bu 5’li setin yanında 3’lü hediye setin var.</strong><small class="bts2-ready-trigger__price" style="color:#ff4712!important;">3 rengi ve kesimi sen seç · HEDİYEMİ SEÇ →</small></button><div class="bts2-ready-choices" hidden><div class="bts2-ready-choices__header"><div><strong>HEDİYE 3’LÜ SETİNİ SEÇ</strong><small>Hazır set seçebilir veya kendi 3 rengini ve kesimini belirleyebilirsin.</small></div><button type="button" class="bts2-ready-close">Kapat</button></div><div class="bts2-ready-choices__options"><button type="button" class="bts2-ready-choice" data-bts-ready-custom><strong>KENDİ 3’LÜ HEDİYEMİ OLUŞTURACAĞIM</strong><span>Classic Bikini, Thong veya karışık kesim; üç rengi kendin seç.</span></button><button type="button" class="bts2-ready-choice" data-bts-ready-pack><strong>HAZIR 3’LÜ HEDİYE KUTUSU SEÇECEĞİM</strong><span>Siyah, bej, kahve, The Classics, The Essentials ve diğer hazır paketler.</span></button></div><div class="nov-gift-picker-host" data-bts-ready-gift-list hidden></div><p class="bts2-ready-status" data-bts-ready-error role="alert"></p></div>`;
    action.after(offer);
    const trigger = offer.querySelector('.bts2-ready-trigger');
    const choices = offer.querySelector('.bts2-ready-choices');
    const errorNode = offer.querySelector('[data-bts-ready-error]');
    const close = () => { choices.hidden = true; trigger.setAttribute('aria-expanded', 'false'); };
    trigger.addEventListener('click', () => {
      choices.hidden = !choices.hidden;
      trigger.setAttribute('aria-expanded', choices.hidden ? 'false' : 'true');
      if (!choices.hidden) B.scrollTo(choices);
    });
    offer.querySelector('.bts2-ready-close')?.addEventListener('click', close);
    offer.querySelector('[data-bts-ready-pack]')?.addEventListener('click', () => {
      const host = offer.querySelector('[data-bts-ready-gift-list]');
      if (!host) return;
      if (typeof B.mountReadyGifts !== 'function') {
        errorNode.textContent = 'Hazır hediyeler yüklenemedi. Kendi hediye kutunu oluşturabilirsin.';
        return;
      }
      B.mountReadyGifts(host, {
        seed: () => seedFrom(marker),
        onSelect: ({seed,gift,button,errorNode}) =>
          B.addItems({
            items: [B.readyLine(seed,1),B.readyLine(gift,2)],
            button,errorNode,
            tracking:{mode:'ready5_plus_ready3',firstPack:5,secondPack:3,estimatedTotal:seed.price/100}
          })
      });
      B.scrollTo(host);
    });
    /* Eski ücretli ikinci kutu tekrarı kaldırıldı. */
    offer.querySelector('[data-bts-ready-custom]')?.addEventListener('click', () => {
      const builder = [...document.querySelectorAll('dn-home-box-builder')].find((candidate) => candidate.dataset.btsSecondBuilder !== 'true');
      if (!builder) {
        const carry = seedFrom(marker);
        if (!carry.variantId || !carry.price || carry.pack !== 5) {
          errorNode.textContent = '5’li kutu seçimi doğrulanamadı. Lütfen yeniden dene.';
          return;
        }
        try {
          sessionStorage.setItem('serrano_november_gift_seed', JSON.stringify({
            variantId: carry.variantId, price: carry.price, pack: 5,
            title: carry.title, savedAt: Date.now()
          }));
        } catch (error) {
          errorNode.textContent = 'Hediye seçimi aktarılamadı. Ana sayfadaki kutu oluşturucuyu kullanabilirsin.';
          return;
        }
        window.location.assign('/#serrano-home-builder');
        return;
      }
      close();
      B.activateExternalSeed(builder, seedFrom(marker));
    });
  };
  const run = () => {
    if (!window.customElements) return;
    customElements.whenDefined('dn-home-box-builder').then(() => {
      document.querySelectorAll('dn-home-box-builder').forEach(B.enhanceBuilder);
      document.querySelectorAll('[data-bts-ready-pdp]').forEach(enhanceReady);
      try {
        const storageKey = 'serrano_november_gift_seed';
        const savedJson = sessionStorage.getItem(storageKey);
        if (savedJson) {
          const builder = [...document.querySelectorAll('dn-home-box-builder')]
            .find((candidate) => candidate.dataset.btsSecondBuilder !== 'true');
          if (builder) {
            sessionStorage.removeItem(storageKey);
            const saved = JSON.parse(savedJson);
            const fresh = Number.isFinite(Number(saved?.savedAt))
              && Date.now() - Number(saved.savedAt) >= 0
              && Date.now() - Number(saved.savedAt) < 15 * 60 * 1000;
            if (fresh && Number(saved?.pack) === 5 && Number(saved.variantId) > 0 && Number(saved.price) > 0) {
              B.activateExternalSeed(builder, {
                variantId: Number(saved.variantId), price: Number(saved.price), pack: 5,
                title: String(saved.title || '5’li Daily Nuuds kutusu').slice(0, 180)
              });
            }
          }
        }
      } catch (error) {
        try { sessionStorage.removeItem('serrano_november_gift_seed'); } catch (_) {}
      }
    }).catch(() => {});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
  document.addEventListener('shopify:section:load', () => setTimeout(run, 0));
  const observer = new MutationObserver((mutations) => {
    const relevant = mutations.some((mutation) => [...mutation.addedNodes].some((node) => node.nodeType === Node.ELEMENT_NODE && (node.matches?.('dn-home-box-builder,[data-bts-ready-pdp]') || node.querySelector?.('dn-home-box-builder,[data-bts-ready-pdp]'))));
    if (relevant) setTimeout(run, 0);
  });
  const start = () => observer.observe(document.body, { childList: true, subtree: true });
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start, { once: true });
})();
